var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swipe-box-answer matrix-group"},[_c('answer-render',{ref:"answer",attrs:{"config":_vm.config}},[_c('div',{attrs:{"slot":"head"},slot:"head"},[_c('answer-swipe-desc-list',{attrs:{"config":_vm.config,"rules":_vm.rules,"modelKey":"displayTitle"},scopedSlots:_vm._u([{key:"optionList",fn:function(ref){
var model = ref.model;
var index = ref.index;
var crtDescIndex = ref.crtDescIndex;
return [_c('rate-group-answer',{attrs:{"config":_vm.config,"model":model,"rules":_vm.rules,"cvtLang":_vm.cvtLang,"prop":'descList.'+index+'.value',"answerValidate":_vm.answerValidate,"crtDescIndex":crtDescIndex}})]}}])})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77be7062","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/RateGroupBox/RateGroupBoxAnswer.vue
// module id = null
// module chunks = 